<div
  class="h-screen w-screen absolute left-0 top-0 flex align-items-center justify-content-center"
>
  @if (loading | async) {
    <p-progressSpinner />
  }
</div>
<!--
<div *ngIf="!hash">
  <pay-engine  id="elementID" merchant-id="merchant" type="disputes">
  </pay-engine>
</div>
<div *ngIf="hash">

  <pay-engine  id="elementID" merchant-id="merchant" hash="hash" type="disputes">
  </pay-engine>
</div> -->

<div id="hidPayEng"></div>
